import { useSelector } from 'react-redux'
import TwoColumnLayout from '../../layouts/two-column-layout/two-column-layout'
import DriverDetails from './driver-details/driver-details.component'
import DriverSelection from './driver-selection/driver-selection.component'
import { RootState } from '../../store'
import MobileDriverSelection from './mobile-driver-selection/mobile-driver-selection.component'
import { getUserId } from 'utils/common'
import { useGetSubscriptionByUserIdQuery } from 'store/subscriptions/subscriptions.api'

const DriverPage = () => {
  const userId = getUserId()
  useGetSubscriptionByUserIdQuery({ userId }, { skip: !userId })
  const selectedDriver = useSelector(
    (state: RootState) => state.drivers.selectedDriver
  )

  return (
    <TwoColumnLayout>
      <DriverSelection />
      <DriverDetails />
      <MobileDriverSelection selectedDriver={selectedDriver} />
    </TwoColumnLayout>
  )
}

export default DriverPage
